import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function languageLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
